export default "__VITE_ASSET__By$GGDzG__"